<ion-button (click)="scanEquipementQrCode()" [disabled]="!canScanQrCode()">
  <ion-icon name="qr-code" />
</ion-button>
